<template>
  <div>
    <hint-widget hintName="statisticsGeneral" type="text" btnMore></hint-widget>

    <v-layout class="py-4" :wrap="$vuetify.breakpoint.smAndDown">
      <v-flex
        class="shrink pt-0 pb-2 mt-0 pt-md-4 mt-md-2 mr-4"
        :class="{ xs12: $vuetify.breakpoint.smAndDown }"
      >
        <v-switch
          v-model="switcher"
          :disabled="!!filterParams.type"
          label="Сравнить"
          class="ma-0 mt-1"
          height="36"
        ></v-switch>
      </v-flex>
      <v-flex
        v-if="filterParams.hotspotName || filterParams.type"
        class="shrink"
      >
        <statistics-filter
          v-if="!switcher"
          @filter="filterItems"
          search-label="Телефон"
          :filters="['hotspot', 'range', 'search', 'country']"
          :default-params="filterParams"
          :loading="loading"
        ></statistics-filter>

        <statistics-filter-comparision
          v-else
          @filter="filterItems"
          :filters="['hotspot', 'range', 'search', 'country']"
          :default-params="filterParams"
          :loading="loading"
        ></statistics-filter-comparision>
      </v-flex>
      <v-flex
        class="shrink pt-3 mt-2 ml-0 ml-sm-3"
        :class="{ xs12: $vuetify.breakpoint.smAndDown }"
      >
        <v-layout :class="{ 'justify-end': $vuetify.breakpoint.smAndDown }">
          <v-btn
            @click="filterItems(paramsForChart)"
            :loading="loading"
            class="primary mx-0 mb-0 mt-1"
          >
            Показать
          </v-btn>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-flex xs12>
      <statistics-general
        v-if="!switcher"
        :filter-params="paramsForChart"
        @isLoading="isLoading"
        @setFilter="setFilter"
        @editSmsDialog="editSmsDialog"
        ref="statistics"
      ></statistics-general>
      <statistics-general-comparision
        v-else
        :filter-params="paramsForChart"
        @isLoading="isLoading"
        @setFilter="setFilter"
        ref="statistics"
      ></statistics-general-comparision>
    </v-flex>
  </div>
</template>

<script>
import moment from "moment";
import HintWidget from "../common/HintWidget.vue";
import StatisticsFilterComparision from "./StatisticsFilterComparision.vue";
import StatisticsGeneralComparision from "./StatisticsGeneralComparision.vue";
import StatisticsGeneral from "./StatisticsGeneral.vue";
import StatisticsFilter from "./StatisticsFilter.vue";

export default {
  name: "StatisticsGeneralMain",

  components: {
    HintWidget,
    StatisticsGeneral,
    StatisticsFilter,
    StatisticsGeneralComparision,
    StatisticsFilterComparision
  },

  props: {
    // объект детализации графика
    filterParams: {
      type: Object,
      default: function() {
        return {
          chartTypeDetail: "day",
          hotspotName: "",
          range: {
            startDate: moment().subtract(1, "month"),
            endDate: new Date()
          },
          search: "",
          country: null,
          hotspot_id: null
        };
      }
    }
  },

  data: () => ({
    // статус загрузки
    loading: false,
    // переключение для сравнения
    switcher: false,
    // переменная для формирования массива хотспотов из сравнения
    filterParamsToCompare: null,
    // объект данных для отправки в график
    paramsForChart: null
  }),

  beforeMount() {
    // состояние свитчера, если загрузка из шаблонов
    this.switcher = this.filterParams.switcher
      ? this.filterParams.switcher
      : false;
  },

  mounted() {
    // задаются значения по умолчанию
    this.paramsForChart = this.filterParams;
    this.filterParamsToCompare = [this.filterParams, this.filterParams];
  },

  watch: {
    // состояние свитчера на момент загрузки компонента
    filterParams() {
      this.switcher = this.filterParams.switcher
        ? this.filterParams.switcher
        : false;
    },
    // обновление данных при изменениях фильтра
    filterParamsToCompare() {
      if (this.switcher) {
        this.paramsForChart = this.filterParams.switcher
          ? this.filterParams.params
          : this.filterParamsToCompare;
      }
    },
    // обновление данных при изменениях свитчера (для сравнения)
    switcher() {
      if (this.switcher) {
        this.paramsForChart = this.filterParams.switcher
          ? this.filterParams.params
          : this.filterParamsToCompare;
      } else {
        this.paramsForChart = this.filterParams;
      }
    }
  },

  methods: {
    /**
     * Фильтрация данных
     */
    filterItems(params) {
      if (params.switcher) {
        this.filterParamsToCompare = params.params;
      } else {
        this.paramsForChart = params;
      }
      // передаем через метод в StatisticsGeneralMain текущие параметры фильтра для шаблонов
      this.setFilter(params);
    },

    /**
     * Отправка смс
     */
    editSmsDialog(params) {
      this.$emit("editSmsDialog", params);
    },

    /**
     * Отправка данных в родительский компонент
     */
    setFilter(params) {
      // задает тип детализации при изменении данных
      this.filterParams.chartTypeDetail = params.length
        ? params[0].chartTypeDetail
        : params.chartTypeDetail;

      this.$emit("setFilter", {
        switcher: this.switcher,
        params: params
      });
    },

    /**
     * Изменение статуса загрузки компонентов
     */
    isLoading(value) {
      this.loading = value;
    }
  }
};
</script>
